import appConfig from 'app.config'
import React, {
	Context,
	PropsWithChildren,
	ReactElement,
	ReactNode,
	createContext,
	useState,
	useEffect,
} from 'react'
import {
	CountryValuesProductType,
	ICountryValues,
} from 'constants/countryValueTypes'
import { countryValues } from 'constants/countryValues/countryValues'
import { useTranslation } from 'react-i18next'

interface IMyPagesContextProps {
	staticCountryValues: ICountryValues | undefined
	productType: CountryValuesProductType | undefined
}

const MyPagesContext: Context<IMyPagesContextProps> =
	createContext<IMyPagesContextProps>({
		staticCountryValues: undefined,
		productType: undefined,
	})

export function MyPagesContextProvider({
	children,
}: PropsWithChildren<ReactNode>): ReactElement {
	const [staticCountryValues, setStaticCountryValues] = useState<
		ICountryValues | undefined
	>(undefined)
	//eslint-disable-next-line
	const [productType, setProductType] = useState<
		CountryValuesProductType | undefined
	>(CountryValuesProductType.All)

	useEffect(() => {
		GetStaticCountryValues()
	}, [productType])

	const GetStaticCountryValues = () => {
		let value = countryValues.find((item) => {
			if (item.country === appConfig.country) {
				return item
			} else {
				return undefined
			}
		})
		setStaticCountryValues(value)
	}

	function getLangAttribute(input: string): string {
		switch (input) {
			case 'dk':
				return 'da'
			case 'ee':
			case 'et':
				return 'et-EE'
			case 'lt':
				return 'lt-LT'
			case 'nb':
			case 'no':
				return 'nb-NO'
			case 'se':
				return 'sv'
			default:
				return input
		}
	}
	const { i18n } = useTranslation()
	useEffect(() => {
		const html = document.documentElement
		const applyLang = () => {
			const lang = getLangAttribute(i18n.language)
			if (html.lang !== lang) {
				html.lang = lang
			}
		}
		applyLang()
		const observer = new MutationObserver(() => {
			applyLang()
		})
		observer.observe(document.documentElement, {
			attributes: true,
			attributeFilter: ['lang'],
		})
		return () => {
			observer.disconnect()
		}
	}, [i18n.language])

	return (
		<MyPagesContext.Provider
			value={{
				staticCountryValues,
				productType,
			}}>
			{children}
		</MyPagesContext.Provider>
	)
}

export default MyPagesContext